import { useState, useEffect } from "react";
import { toast } from "react-toastify";
import axios from 'axios';
import Dashboard from './Dashboard';
import React from "react";

export default function TaskAssignment(){
  const user_id = localStorage.getItem("user");
  const ryts = localStorage.getItem("user_rights");
  const corp_id = localStorage.getItem("business_id");
  const [filtered, setFiltered] = useState("");
  const [closeResponse, setcloseResponse] = useState('displayNone');
  //{id:0,fromusr:user_id,tousr:user_id,startdt:"", deadline:"",title:"",status:"",detail:"" }
  const [exst, setExst] = useState([]);
  const defaulTskFLD = {
      corp_id: corp_id,
      user_id: user_id,
      ryts: ryts,
      id:0,
      status:"",
      title:"",
      newDtl:"",
      detail:"",
      indetail:[{id:0}],
      module: "chngTsk",
      product: "quotationB",  
  };
  const [chng, setchng] = useState({
      corp_id: corp_id,
      user_id: user_id,
      ryts: ryts,
      id:0,
      status:"",
      title:"",
      newDtl:"",
      detail:"",
      indetail:[{id:0}],
      module: "chngTsk",
      product: "quotationB",  
  });
  const [getTask,setGetTask] = useState({
      corp_id: corp_id,
      user_id: user_id,
      ryts: ryts,
      idis: 0,
      module: "getTsk",
      product: "quotationB",  
  });
  const getOrgMem =({
    cusID: 0,
    corp_id: corp_id,
    user_id: user_id,
    task: "y",
    module: "getOrgMem",
    product: "quotationB",
  });

  const dt = new Date();  
  let date = String(dt.getDate()).padStart(2, '0');;
  let month = String(dt.getMonth()).padStart(2, '0');
  let year = dt.getFullYear();
  const dts = year+"-"+month+"-"+date;
  const [currentDate, setCurrentDate] = useState();
  const [orgMembers, setOrgMembers] = useState([{id:0, name:"Harleen Grover"}]);

  const [tsk, settsk] = useState({
    status:"assigned",fromusr:user_id,corp_id:corp_id, tousr:0,deadline:"",startdt:"",module:"tasManage", product: "quotationB"
  });
  async function AxiosTask(tsks){
    toast.warning("please wait!");
    JSON.stringify(tsks);
    axios({
      method: "post",
      url: "./reactManager/",
      data: tsks,
    }).then((res) => {
      toast.dismiss();
        if(tsks.module=="getOrgMem" && res.data.data!=undefined){
          setOrgMembers(res.data.data);
        }
        if(tsks.module=="addTask"){
          settsk(res.data.data);
        }
        if(tsks.module=="getTsk"&& res.data.data!=null&& res.data.data!=undefined){
          setExst(res.data.data);
        }
        if(tsks.module=="getTskDtl" && res.data.data!=undefined){
          setchng({...res.data.data,["module"]:"tasManage",["product"]: "quotationB",["corp_id"]: corp_id,["user_id"]: user_id,["ryts"]: ryts,});
        }
        if(tsks.module=="tasManage"){
          if(tsks.id == undefined){ setchng(defaulTskFLD); AxiosTask(getTask);}
          toast.success("message sent successfully!");
          const currentDate = new Date();
          const isoString = currentDate.toISOString(); 
          var addnew = (chng.indetail!=null) ? [...chng.indetail,{["detail"]:tsks.status+" - "+tsks.newDtl,["user_id"]:tsks.user_id,["date"]:isoString}] : [{["detail"]:tsks.status+" - "+tsks.newDtl,["user_id"]:tsks.user_id,["date"]:isoString}] ;
          //console.log(addnew);
          setchng({...chng,["indetail"]:addnew,['newDtl']:""});
          
          setTimeout(()=>{
            const myDiv = document.getElementById("detailTask");
            myDiv.scrollTop = myDiv.scrollHeight;
          },1000);
        }
    });
  }
  const handleFilter = (event)=>{
    const { name, value } = event.target;
    setFiltered(value);
  }
  const handleField = (e)=>{
    const { name, value } = e.target;
    settsk({...tsk,[name]: value,});
  }
  const handleChngFld = (e)=>{
    const { name, value } = e.target;
    setchng({...chng,[name]: value,});
  }
  function handleTsk(e){
    e.preventDefault();
    setGetTask({...getTask,['idis']:0,['module']:"getTsk"});
    AxiosTask(tsk);
  }
  function changeTsk(e){
    e.preventDefault();
    AxiosTask(chng);
  }
  const specificTask = (findSPecific)=>{
    setGetTask({...getTask,['idis']:findSPecific,['module']:"getTskDtl"});
    AxiosTask(getTask);
    setcloseResponse("udtStatus");
    setTimeout(()=>{
      const myDiv = document.getElementById("detailTask");
      myDiv.scrollTop = myDiv.scrollHeight;
    },2000);
  }
  useEffect(() => {
    AxiosTask(getOrgMem);
    AxiosTask(getTask);
  }, [getTask]);
  
  return(
      <div><Dashboard></Dashboard>
      <div id="content_area">
        <div className={closeResponse}>
                <span id='closeIt'  onClick={()=>{setcloseResponse("displayNone");}}>close</span>
                <div>
                  <div className="detailTask" id="detailTask">
                      <div className="mine">
                        <small><small>
                            <i>Assigned - {chng.startdt}</i>
                        </small></small><br />
                        <small>
                          {orgMembers.filter(orgM=>orgM.id==chng.fromusr).map((dta)=>{ return dta.name})}:  
                        </small>
                        {" "+chng.detail}
                      </div>
                      { (chng.indetail != null) ?
                          chng.indetail.map((dtls)=>{
                            const cls = (chng.fromusr == dtls.user_id) ? "mine" : "other" ;
                          return <>
                            <div className={cls}>
                              <small><small>
                                  <i>{dtls.date}</i>
                              </small></small><br />
                              <small>
                                {orgMembers.filter(orgM=>orgM.id==dtls.user_id).map((dta)=>{ return dta.name })}: 
                              </small>{" "+dtls.detail}
                            </div>
                          </>
                        }) : " "
                      };
                    </div>
                  <form onSubmit={changeTsk} id="formTsk">
                    <h3>({chng.status}) - {chng.title}</h3>
                  <select value={chng.status} name='status' onChange={handleChngFld}>
                  <option value="assigned">Assigned</option>
                  <option value="delayed">Delayed</option>
                  <option value="cancelled">Cancelled</option>
                  <option value="deferred">Deferred</option>
                  <option value="done">Done</option>
                </select>
                <textarea placeholder="reply..." onChange={handleChngFld} required name="newDtl">{chng.newDtl}</textarea>
                <input type="submit" value={"Update"} />
                </form></div>
                      
                </div>
        <h2>Task Management</h2>
        <div id="list_section"></div>
        <form method="post" name="customerForm" onSubmit={handleTsk}>
          <h2>Assign new task</h2>
          {/* <small>Assignment Status :<br /></small>
          <select onChange={handleField} value={tsk.status} name='status' required>
            <option selected value="">Select</option>
            <option value="assigned">Assigned</option>
             <option value="delayed">Delayed</option>
            <option value="cancelled">Cancelled</option>
            <option value="deferred">Deferred</option>
            <option value="done">Done</option> 
          </select> */}
          <small>Assignment To :<br /></small>
          <select onChange={handleField} value={tsk.to} name='tousr' required>
              <option value={''}>Select one</option>
              {orgMembers.map((orgM)=>{
                let nm = (orgM.id==user_id) ? orgM.name+" (My Self)" : orgM.name ;
                return <option value={orgM.id}>{nm}</option> 
                })
              }</select><br /><br />
          <small>Title :</small>  <br />
            <input type="text" name="title" value={tsk.title} required placeholder="Task Heading" onChange={handleField} />
            <br /><br />
            <small>Deadline :</small><br />
            <input type="date" name="deadline" value={tsk.deadline} required placeholder="0000-00-00" onChange={handleField} />
            <br /><br />
            <small>Detail :</small><br />
            <textarea placeholder="Task Detail" onChange={handleField} required name="detail">{tsk.detail}</textarea><br /><br />
            <input type="submit" name="subMit" value="Submit Task" />
        </form>
        
        <div id="list_section">
          <h2>Tasks</h2>
          <h3><form style={{float:'none'}}>
            <input type="text" onChange={handleFilter} placeholder="filter list by name"  value={filtered}  />
          </form></h3>
          
          <br />
          <div>
            <ul>
            
              {exst.filter(function(d){return d.title.toLowerCase().indexOf(filtered.toLowerCase())!=-1;}).map((exs)=>{  
                  var clsot = (exs.ac_id==0) ? "tskli " : "tskli other" ;
                  if(exs.deadline<dts){ clsot = "tskli error"; }
                  if(exs.status=="done"){ clsot = "tskli success"; }
                  var frmnm = orgMembers.filter(orgM=>orgM.id==exs.fromusr);
                  var tonm = orgMembers.filter(orgM=>orgM.id==exs.tousr);
                  return <li onClick={()=>{specificTask(exs.id)}} key={exs.id} className={clsot} >
                    <p><small className="to-end">{corp_id+exs.id}</small><br />
                    <b>{exs.title} </b> <br />
                    <small><i>Status: {exs.status}  / Deadline: {exs.deadline}</i> <br />
                    <i>From: {(frmnm[0]) ? frmnm[0].name : ""} to {(tonm[0]) ?  tonm[0].name :""} </i></small><br />
                    <small>Detail: {exs.detail.substring(0, 100)+"..."}</small>
                      </p>
                  </li>;
            })}
            </ul>
           
          </div>
        </div>
        </div>
              
      </div>
)
}